import React, { useMemo } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import type { BlockRow } from '../hooks/useBlocks';
import { whoMessages as messages } from './whoMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for step 2; each part uses its own slice of it */
import styles from './Who.module.scss';
/* eslint-enable css-modules/no-unused-class */

const KIND_LABEL: Record<BlockRow['kind'], MessageDescriptor> = {
  email: messages.neverKindEmail,
  domain: messages.neverKindDomain,
  playlist: messages.neverKindPlaylist,
  contact: messages.neverKindContact,
};

interface NeverContactChipsProps {
  blocks: BlockRow[];
  readOnly: boolean;
  onRemove: (blockUuid: string) => void;
}

/** The blocks of the artist as chips with their kind and a remove button (design outreach-v2 c1 `ncchip`). */
const NeverContactChipsComponent: React.FC<NeverContactChipsProps> = ({ blocks, readOnly, onRemove }) => {
  const intl = useIntl();
  const chips = useMemo(
    () =>
      blocks.map((block) => (
        <span key={block.blockUuid} className={styles.ncChip} data-testid="never-contact-chip">
          <span className={styles.ncKind}>{intl.formatMessage(KIND_LABEL[block.kind])}</span>
          {block.label}
          {!readOnly && (
            <button
              type="button"
              className={styles.ncRemove}
              aria-label={intl.formatMessage(messages.neverRemove, { label: block.label })}
              onClick={() => onRemove(block.blockUuid)}
            >
              ✕
            </button>
          )}
        </span>
      )),
    [blocks, intl, onRemove, readOnly]
  );
  if (chips.length === 0) {
    return null;
  }
  return <div className={styles.chips}>{chips}</div>;
};

export const NeverContactChips = TypedMemo(NeverContactChipsComponent);
